import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Loader from "react-js-loader";
import Idenfy from "./IdenfyModal";
import { connect, useDispatch } from "react-redux";
import { withTranslation } from "react-i18next";
import { selectAPICallMultiple } from "@ensuro/api-calls-store/src/store/api/selectors";
import {
  selectIdenfyToken,
  selectKycSignature,
  selectUserAddress,
  selectLiteracyTestAnswers,
} from "../../store/user/selectors";
import { SET_KYC_STEP, SET_IDENFY_TOKEN, SET_KYC_STATUS } from "../../store/user/actionTypes";

const makeAPICalls = (address, kycSignature, literacyTestAnswers) => [
  {
    apiName: "storeKYC",
    args: [address],
    method: "POST",
    data: {
      address: address,
      message: kycSignature.message,
      signature: kycSignature.signature,
      email: kycSignature.email || "",
      start_kyc: "idenfy",
      literacy_test_answers: literacyTestAnswers,
      data: {},
    },
  },
];

const StepIdenfy = ({ userAddress, authToken, kycSignature, storeKYCCall, literacyTestAnswers }) => {
  let dispatch = useDispatch();
  useEffect(() => {
    const receiveMessage = (event) => {
      if (event.origin === "https://ui.idenfy.com" && event.data && event.data.status) {
        dispatch({ type: SET_KYC_STEP, step: "verificationDetails" });
        dispatch({ type: SET_IDENFY_TOKEN, idenfyToken: null });
      }
    };
    window.addEventListener("message", receiveMessage, false);
    return () => window.removeEventListener("message", receiveMessage, false);
  }, [dispatch]);

  useEffect(() => {
    if (!authToken) {
      const [apiCallConfig] = makeAPICalls(userAddress, kycSignature, literacyTestAnswers);
      dispatch({
        type: "API_CALL",
        ...apiCallConfig,
      });
    }
  }, [authToken, kycSignature, userAddress, literacyTestAnswers, dispatch]);

  useEffect(() => {
    if (!storeKYCCall) {
      // Go back one step
      dispatch({ type: SET_KYC_STEP, step: "signIn" });
    } else if (storeKYCCall.state === "ERROR") {
      dispatch({
        type: SET_KYC_STATUS,
        kycStatus: "idenfyError",
        amlPass: null,
        sanctionsPass: null,
        literacyTestPass: null,
        idenfyError: storeKYCCall,
      });
      dispatch({ type: SET_KYC_STEP, step: "kycStatus" });
    }
  }, [storeKYCCall, dispatch]);

  if (!authToken) {
    return <Loader type="spinner-default" height={50} width={100} timeout={1000} />;
  }
  return <Idenfy idenfyToken={authToken} />;
};

StepIdenfy.propTypes = {
  t: PropTypes.any,
  authToken: PropTypes.string,
};

const mapStateToProps = (state) => {
  const userAddress = selectUserAddress(state.UserReducer);
  const authToken = selectIdenfyToken(state.UserReducer);
  const kycSignature = selectKycSignature(state.UserReducer);
  const literacyTestAnswers = selectLiteracyTestAnswers(state.UserReducer);
  const [storeKYCCall] = selectAPICallMultiple(
    state.APIReducer,
    kycSignature && userAddress ? makeAPICalls(userAddress, kycSignature, literacyTestAnswers) : []
  );
  return {
    userAddress: userAddress,
    authToken: authToken,
    kycSignature: kycSignature,
    storeKYCCall: storeKYCCall,
    literacyTestAnswers: literacyTestAnswers,
  };
};

export default connect(mapStateToProps)(withTranslation()(StepIdenfy));
